import Home from "./Home";
import Login from "./Login";
import MFA from "./MFA";
import Tools from "./Tools";
import Password from "./Password";
import Users from "./Users";
import Roles from "./Roles";
import Projects from "./Projects";
import Tasks from "./Tasks";
import UsersGroup from "./UsersGroup";
import Notifications from "./Notification";
import News from "./News";
import Countries from "./Countries";
import Map from "./Map";
import Questions from "./Questions";
import Brands from "./Brands";
import Payments from "./Payments";
import Faqs from "./Faqs";
import Profiler from "./Profiler";
import Dashboard from "./Dashboard";
import Analytic from "./Analytic";
import Membeer from "./Membeers";
import PowerBI from "./PowerBI";
import LaunchApp from "./LaunchApp";
import Gamification from "./Gamification";
import Legal from "./Legal";
import PromptsMain from "./Prompts/Main";
import PromptConfigMain from "./PromptConfig";
import SubItems from "./SubItems";
import Forbidden from "./Forbidden/Forbidden";
import NotFound from "./NotFound/NotFound";
import Settings from "./Settings";

const useScreens = () => {
  return {
    Login,
    MFA,
    Home,
    Tools,
    Users,
    Roles,
    Tasks,
    Projects,
    Password,
    UsersGroup,
    Notifications,
    News,
    Countries,
    Map,
    Questions,
    Brands,
    Payments,
    Faqs,
    Profiler,
    Dashboard,
    Analytic,
    Membeer,
    PowerBI,
    LaunchApp,
    Gamification,
    Legal,
    PromptsMain,
    PromptConfigMain,
    SubItems,
    Forbidden,
    NotFound,
    Settings
  };
};

export default useScreens;
